import type { ShadowPlan } from '../../services/shadowPlans.api';
import { formatTimeBaghdad } from '../../utils/date';
import { SHIFT_HOURS, VAN_LABEL, shiftRows } from './shadowPlanView';

/** Drivers needed per shift, with their working hours and load. */
export default function ShadowShiftSummary({ plan }: { plan: ShadowPlan }) {
  const rows = shiftRows(plan);
  return (
    <section aria-label="Drivers per shift" className="space-y-2">
      <div className="grid gap-3 sm:grid-cols-3">
        {rows.map((r) => (
          <div key={r.type} className="rounded-lg border border-gray-200 bg-white p-3">
            <p className="text-xs text-gray-500">{VAN_LABEL[r.type]} · {SHIFT_HOURS[r.type]}</p>
            <p className="mt-1 text-2xl font-semibold text-gray-900 tabular-nums">
              {r.drivers} <span className="text-sm font-normal text-gray-500">{r.drivers === 1 ? 'driver' : 'drivers'}</span>
            </p>
            <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-0.5 text-xs text-gray-600 tabular-nums">
              <dt>Working</dt>
              <dd>{formatTimeBaghdad(r.firstStart)}–{formatTimeBaghdad(r.lastEnd)}</dd>
              <dt>Hours per driver</dt>
              <dd>{r.avgHours} h on average</dd>
              <dt>Stops</dt>
              <dd>{r.stops} ({r.stops - r.expected} booked)</dd>
              <dt>Orders · returns</dt>
              <dd>{r.orders} · {r.returns}</dd>
              {r.type === 'COLD' && (
                <>
                  <dt>Cold stops</dt>
                  <dd>{r.cold}</dd>
                </>
              )}
            </dl>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-500">
        Slot times come from Fleet&apos;s slot settings. The planner chooses each driver&apos;s start and end: a van may start up to
        90 min before its first slot and finish up to 2 h after its last one, and works at most 9 h (planned to about 7.6 h). Every route starts and ends at the warehouse; the times shown run from the
        first stop to the last.
      </p>
    </section>
  );
}
